export default __webpack_public_path__ + "static/media/xmas_2023-id.e8aa9325.jpg";